export default "__VITE_ASSET__Bs07Rnnl__"